import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithDecryption } from "../baseQueryWithEncryption";

export const ApiCollectionApi = createApi({
  reducerPath: "ApiCollectionApi",
  tagTypes: [
    "RequestDetails",
    "sharedCollection",
    "monitoring",
    "monitorHistory",
  ],
  baseQuery: baseQueryWithDecryption(import.meta.env.VITE_COLLECTION_API_URL),
  endpoints: (builder) => ({
    getCollectionsByWorkspaceId: builder.query({
      query: (id) => `/api-collection/workspace/${id}`,
    }),
    createRequest: builder.mutation({
      query: (body) => ({
        url: "/api-collection/request",
        method: "POST",
        body,
      }),
    }),
    // getProjectOrReposForImport: builder.query({
    //   query: (from) => ({
    //     url: "gateway/projects",
    //     method: "GET",
    //     params: { from },
    //   }),
    // }),
    // getRepoBranches: builder.mutation({
    //   query: ({ repoName, from }) => ({
    //     url: `/repo-branches?from=${from}`,
    //     method: "POST",
    //     body: { repoName },
    //   }),
    // }),
    getApplicationsByProjectId: builder.query({
      query: ({ projectId }) => `/applications/project/${projectId}`,
    }),
  }),
});

export const {
  useGetCollectionsByWorkspaceIdQuery,
  useCreateRequestMutation,
  // useGetProjectOrReposForImportQuery,
  // useGetRepoBranchesMutation,
  useGetApplicationsByProjectIdQuery,
} = ApiCollectionApi;
